export enum Merediem {
  AM = 'AM',
  PM = 'PM',
}

export enum TaxExemptSection {
  Section501c3 = '501(c)3',
}

export enum Languages {
  English = 'en',
  Spanish = 'es',
  French = 'fr',
  German = 'de',
  Chinese = 'zh',
  Japanese = 'ja',
  Hindi = 'hi',
  Arabic = 'ar',
  Russian = 'ru',
  Portuguese = 'pt',
}

export enum CurrencyTypes {
  USD = 'USD',
}

export enum PhoneFormatTypes {
  Format1 = '###-###-####', //###-###-####
  Format2 = '(###) ###-####', //(###) ###-####
}

export enum DateFormat {
  Format1 = 'Mon DD, YYYY', // Mon DD, YYYY
  Format2 = 'MM-DD-YY', // MM-DD-YY
  Format3 = 'MM-DD-YYYY', // MM-DD-YYYY
  Format4 = 'MM/DD/YY', // MM/DD/YY
  Format5 = 'MM/DD/YYYY', // MM/DD/YYYY
  Format6 = 'YY-MM-DD', // YY-MM-DD
  Format7 = 'YYYY-MM-DD', // YYYY-MM-DD
  Format8 = 'DD Mon YYYY', // DD Mon YYYY
  Format9 = 'DD Month YYYY', // DD Month YYYY
  Format10 = 'Month DD, YYYY', // Month DD, YYYY
  Format11 = 'Day, Mon DD, YYYY', // Day, Mon DD, YYYY
}

export enum NumberFormat {
  Format1 = '1,234,567.89',
  Format2 = '1.234.567,89',
  Format3 = '1 234 567,89',
  Format4 = "1'234'567.89",
  Format5 = '1234567.89',
}
